export enum SearchMode {
	Tours = 'tours',
	Hotels = 'hotels',
}
